<app-shell (openFirmPicker)="firmPickerOpen = true">
  <ng-container *ngIf="contextReady; else contextLoading">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #contextLoading>
    <!-- Minimal spinner while org context resolves (cache-hit path is <50ms) -->
    <div class="context-loading">
      <div class="context-loading-spinner"></div>
    </div>
  </ng-template>
</app-shell>

<app-firm-picker-modal
  [open]="firmPickerOpen"
  (close)="firmPickerOpen = false"
></app-firm-picker-modal>

<app-firm-context-picker
  *ngIf="pickerConfig !== null"
  [mode]="pickerConfig.mode"
  [groups]="pickerConfig.groups"
  [orgs]="pickerConfig.orgs"
  (groupChange)="onPickerGroupChange($event)"
  (contextSelected)="onPickerContextSelected($event)"
></app-firm-context-picker>

<toaster></toaster>
